/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerimeterPointDto } from './PerimeterPointDto';
import {
    PerimeterPointDtoFromJSON,
    PerimeterPointDtoFromJSONTyped,
    PerimeterPointDtoToJSON,
    PerimeterPointDtoToJSONTyped,
} from './PerimeterPointDto';
import type { SiteLocationSummaryResponseDto } from './SiteLocationSummaryResponseDto';
import {
    SiteLocationSummaryResponseDtoFromJSON,
    SiteLocationSummaryResponseDtoFromJSONTyped,
    SiteLocationSummaryResponseDtoToJSON,
    SiteLocationSummaryResponseDtoToJSONTyped,
} from './SiteLocationSummaryResponseDto';

/**
 * 
 * @export
 * @interface SiteLookupResponseDto
 */
export interface SiteLookupResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SiteLookupResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SiteLookupResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SiteLookupResponseDto
     */
    address: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiteLookupResponseDto
     */
    postalCode: string | null;
    /**
     * 
     * @type {SiteLocationSummaryResponseDto}
     * @memberof SiteLookupResponseDto
     */
    city: SiteLocationSummaryResponseDto | null;
    /**
     * 
     * @type {SiteLocationSummaryResponseDto}
     * @memberof SiteLookupResponseDto
     */
    province: SiteLocationSummaryResponseDto | null;
    /**
     * 
     * @type {number}
     * @memberof SiteLookupResponseDto
     */
    latitude: number | null;
    /**
     * 
     * @type {number}
     * @memberof SiteLookupResponseDto
     */
    longitude: number | null;
    /**
     * 
     * @type {Array<PerimeterPointDto>}
     * @memberof SiteLookupResponseDto
     */
    perimeter: Array<PerimeterPointDto> | null;
}

/**
 * Check if a given object implements the SiteLookupResponseDto interface.
 */
export function instanceOfSiteLookupResponseDto(value: object): value is SiteLookupResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('province' in value) || value['province'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('perimeter' in value) || value['perimeter'] === undefined) return false;
    return true;
}

export function SiteLookupResponseDtoFromJSON(json: any): SiteLookupResponseDto {
    return SiteLookupResponseDtoFromJSONTyped(json, false);
}

export function SiteLookupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteLookupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'address': json['address'],
        'postalCode': json['postalCode'],
        'city': SiteLocationSummaryResponseDtoFromJSON(json['city']),
        'province': SiteLocationSummaryResponseDtoFromJSON(json['province']),
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'perimeter': (json['perimeter'] == null ? null : (json['perimeter'] as Array<any>).map(PerimeterPointDtoFromJSON)),
    };
}

export function SiteLookupResponseDtoToJSON(json: any): SiteLookupResponseDto {
    return SiteLookupResponseDtoToJSONTyped(json, false);
}

export function SiteLookupResponseDtoToJSONTyped(value?: SiteLookupResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'address': value['address'],
        'postalCode': value['postalCode'],
        'city': SiteLocationSummaryResponseDtoToJSON(value['city']),
        'province': SiteLocationSummaryResponseDtoToJSON(value['province']),
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'perimeter': (value['perimeter'] == null ? null : (value['perimeter'] as Array<any>).map(PerimeterPointDtoToJSON)),
    };
}

